import { Link } from "react-router-dom";
import type { CaseItem } from "@/mocks/cases";
import { formatHeat } from "@/utils/format";

export default function CaseHero({ item }: { item: CaseItem }) {
  return (
    <section className="relative w-full overflow-hidden">
      <img
        src={item.cover}
        alt={`${item.title} 档案详情封面`}
        title={`${item.title} - 独家黑料证据链`}
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/55 to-black/40" />

      <div className="relative w-full px-4 md:px-8 pt-6 pb-10 md:pt-8 md:pb-14">
        <nav aria-label="面包屑导航" className="text-sm text-white/70">
          <ol className="flex flex-wrap items-center gap-2">
            <li>
              <Link to="/" className="hover:text-white transition-colors cursor-pointer">
                首页
              </Link>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-arrow-right-s-line" />
              <Link to="/archive" className="hover:text-white transition-colors cursor-pointer">
                爆料档案库
              </Link>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-arrow-right-s-line" />
              <Link
                to={`/archive?cat=${item.category}`}
                className="hover:text-white transition-colors cursor-pointer"
              >
                {item.categoryName}
              </Link>
            </li>
          </ol>
        </nav>

        <div className="mt-6 max-w-4xl">
          <div className="flex flex-wrap items-center gap-2">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-md bg-accent-500 text-primary-950 text-xs font-medium whitespace-nowrap">
              <i className="ri-file-text-line" />
              {item.categoryName}
            </span>
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-md bg-white/15 text-white text-xs backdrop-blur whitespace-nowrap">
              <i className="ri-loader-4-line" />
              {item.status}
            </span>
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-md bg-white/15 text-white text-xs backdrop-blur whitespace-nowrap">
              档案编号 {item.id.toUpperCase()}
            </span>
          </div>

          <h1 className="mt-5 font-heading text-2xl md:text-4xl font-bold leading-tight text-white">{item.title}</h1>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-white/80">{item.summary}</p>

          <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs md:text-sm text-white/75">
            <span className="flex items-center gap-1.5">
              <i className="ri-calendar-line" />
              建立于 {item.publishedAt}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-fire-line" />
              热度 {formatHeat(item.heat)}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-time-line" />
              约 {item.readMinutes} 分钟读完
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}